import type { UIStringsOverride } from "../i18n-ui.ts";

/** French (fr) UI strings. */
export const fr: UIStringsOverride = {
  actions: {
    addToCursor: "Ajouter à Cursor",
    addToVscode: "Ajouter à VS Code",
    askAI: "Demander à l'IA à propos de cette page",
    connectMcp: "Se connecter à MCP",
    copied: "Copié !",
    copyClaudeCode: "Copier la commande Claude Code",
    copyCode: "Copier le code",
    copyCodex: "Copier la commande Codex",
    copyMarkdown: "Copier en Markdown",
    copyServerUrl: "Copier l'URL du serveur",
    edit: "Modifier sur GitHub",
    export: "Exporter",
    exportEpub: "Exporter en EPUB",
    exportPdf: "Exporter en PDF",
    generating: "Génération…",
    openIn: "Ouvrir dans {name}",
    openInChat: "Ouvrir dans le chat",
    scrollToTop: "Revenir en haut",
  },
  ask: {
    ai: "IA",
    clear: "Effacer la conversation",
    close: "Fermer",
    copy: "Copier la conversation",
    empty: "Posez une question sur la documentation.",
    error: "Désolé, une erreur s'est produite.",
    label: "Poser une question",
    placeholder: "Posez une question…",
    send: "Envoyer",
    tip: "Astuce : vous pouvez ouvrir et fermer le chat avec",
    title: "Demander à l'IA",
    you: "Vous",
  },
  banner: { dismiss: "Fermer l'annonce" },
  changelog: {
    description: "Nouveautés du produit et notes de version.",
    showReleases: "Afficher les versions {version}",
    title: "Journal des modifications",
  },
  content: {
    diagramError: "Impossible d'afficher ce diagramme.",
  },
  feedback: {
    no: "Non",
    question: "Cette page vous a-t-elle été utile ?",
    thanks: "Merci pour votre retour !",
    yes: "Oui",
  },
  languageSwitcher: { label: "Langue", untranslated: "Non traduit" },
  nav: {
    back: "Retour",
    breadcrumb: "Fil d'Ariane",
    closeNavigation: "Fermer la navigation",
    deprecated: "obsolète",
    featured: "En vedette",
    githubRepository: "Dépôt GitHub",
    navigation: "Navigation",
    primary: "Principal",
    sections: "Sections",
    toggleNavigation: "Afficher ou masquer la navigation",
    toggleTheme: "Changer de thème de couleur",
  },
  notFound: {
    description: "Nous n'avons pas trouvé la page que vous recherchez.",
    home: "Retour à l'accueil",
    title: "Page introuvable",
  },
  page: {
    lastUpdated: "Dernière mise à jour le",
    next: "Suivant",
    pagination: "Pagination",
    previous: "Précédent",
    skipToContent: "Aller au contenu",
  },
  search: {
    all: "Tous",
    allLanguages: "Toutes les langues",
    askAi: "Demander à l'IA",
    askAiHint: "Obtenez une réponse instantanée de l'IA",
    button: "Rechercher",
    devOnly: "La recherche est disponible dans la version de production.",
    error: "Une erreur s'est produite. Veuillez réessayer.",
    label: "Rechercher dans la doc",
    navigate: "naviguer",
    noResults: "Aucun résultat.",
    open: "ouvrir",
    placeholder: "Rechercher dans la documentation…",
    popular: "Populaires",
    preview: "aperçu",
    results: "Résultats",
  },
  toc: { title: "Sur cette page" },
};
